export default "<body-overlay class=\"body-overlay hidden\">\n</body-overlay>";